import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

const Contact = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
          LinkedIn <FaLinkedin size={30} />
        </>
      ),
      href: "https://www.linkedin.com/in/halderdebabrata/",
      style: "rounded-tr-md rounded-tl-md focus:border border-slate-200",
    },
    {
      id: 2,
      child: (
        <>
          GitHub <FaGithub size={30} />
        </>
      ),
      href: "https://github.com/DebabrataHalder",
    },
    {
      id: 3,
      child: (
        <>
          Mail <HiOutlineMail size={30} />
        </>
      ),
      href: "mailto:halderdebabrata.dev@gmail.com",
    },
  ];

  return (
    <div
      name="contact"
      className="w-full h-auto bg-gradient-to-b from-black to-gray-800 p-4 text-white"
    >
      <div className="mt-16 flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-screen">
        <div className="pb-8">
          <p
            style={{ fontFamily: "'Orbitron', sans-serif" }}
            className="text-4xl font-bold inline border-b-4 border-gray-500"
          >
            Contact
          </p>
          <p
            style={{ fontFamily: "sans-serif" }}
            className="py-6"
          >
            Submit the form below to get in touch with me
          </p>
        </div>

        <div className="flex justify-center items-center">
          <form
            action="https://getform.io/f/bjjeqwyb"
            method="POST"
            className="flex flex-col w-full md:w-1/2"
          >
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
              style={{ fontFamily: "sans-serif" }}
            />
            <input
              type="text"
              name="email"
              placeholder="Enter your email"
              className="my-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
              style={{ fontFamily: "sans-serif" }}
            />
            <textarea
              name="message"
              placeholder="Enter your message"
              rows="10"
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
              style={{ fontFamily: "sans-serif" }}
            ></textarea>

            <button
              className="text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md duration-300"
              style={{ fontFamily: "sans-serif" }}
            >
              Let's talk
            </button>
          </form>
        </div>
      </div>
      <div className="flex flex-col top-[35%] left-0 justify-between items-center lg:hidden">
        <ul>
          {links.map(({ id, child, href, style, download }) => (
            <li
              key={id}
              className={
                "flex justify-between items-center w-40 h-14 px-4 duration-300 bg-gray-500" +
                " " +
                style
              }
            >
              <a
                href={href}
                className="flex justify-between items-center w-full text-white"
                download={download}
                target="_blank"
                rel="noreferrer"
                style={{ fontFamily: "sans-serif" }}
              >
                {child}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Contact;

